let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hDMsl")).then(() => parcelRequire('d5Wt5'));